import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Field } from 'formik';

import CitySearchQuery from 'buyside/graphql/queries/CitySearch';

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';

export class CityAutocomplete extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, suggestions: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  selectIntercept(value, selectedItem) {
    const { name, setFieldValue } = this.props;
    setFieldValue(name, selectedItem);
  }

  changeIntercept(query) {
    this.setState({ loading: true });
    this.props.client.query({ query: CitySearchQuery, variables: { query } }).then(res => {
      this.setState({
        loading: false,
        suggestions: res.data.citySearch
      });
    });
  }

  render() {
    const autosuggestOptions = {};
    return (
      <Field
        autosuggestOptions={autosuggestOptions}
        changeIntercept={this.changeIntercept}
        component={AutocompleteField}
        analyticsTag={this.props.analyticsTag}
        debounce
        formatSuggestion={suggestion => suggestion}
        getSuggestionValue={suggestion => suggestion}
        handleSuggestionsClearRequested={() => this.setState({ suggestions: [] })}
        icon={this.props.icon || false}
        isWide
        label={this.props.label || 'City'}
        loading={this.state.loading}
        locked={this.props.locked}
        name={this.props.name}
        placeholder={this.props.placeholder}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.suggestions}
        validate={this.props.validate}
      />
    );
  }
}

export default withApollo(CityAutocomplete);
